/**
 * @fileOverview Cross
 */

export var Cell = function Cell(_props) {
  return null;
};
Cell.displayName = 'Cell';


//////////////////
// WEBPACK FOOTER
// ./~/recharts/es6/component/Cell.js
// module id = ./node_modules/recharts/es6/component/Cell.js
// module chunks = 1